import * as React from 'react';
import { noop } from 'lodash';

const context = React.createContext<{
  setEditingPanelOpen: (open: boolean) => void;
}>({ setEditingPanelOpen: noop });

export const ManagementContextProvider = context.Provider;
export const useManagementContext = () => React.useContext(context);
